import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Helpers
import { confirm, getURLSegment, toggleDrawer } from '../../helpers/helpers.js';

// Dependencies
import Delayed from 'react-delayed';

// Components
import Drawer from '../Drawer/Drawer';
import * as icons from '../Icons/Icons';
import VoucherList from './VoucherList';
import Toolbar from '../Common/Toolbar';

const Vouchers = observer(class Vouchers extends React.Component {
  constructor() {
    super();
    this.deleteVouchers = this.deleteVouchers.bind(this);
  }

  componentWillMount() {
    this.state = {
      drawerOpen: false,
      drawerContent: null,
      selectedRows: []
    };
    this.getVouchers();
  }

  componentDidMount() {
    const { pathname } = this.props.routing.location;
    const { SessionStore } = this.props.store;

    if(getURLSegment(this, 2) === 'edit') {
      SessionStore.loading = false;
      toggleDrawer(null, this, 'EditVoucher');
      const voucherSid = pathname.substr(pathname.lastIndexOf('/') + 1);

      this.setState({
        voucherSid
      });
    }
  }

  getVouchers() {
    this.props.store.VoucherStore.getVouchers();
  }

  deleteVouchers() {
    const { translation } = this.props;

    let msg = {
      heading: translation.delete_confirm.heading_singular,
      body: translation.delete_confirm.body_singular,
      button: translation.delete_confirm.button
    }

    if(this.state.selectedRows.length > 1) {
      msg.heading = translation.delete_confirm.heading_plural.replace('%count%', this.state.selectedRows.length);
      msg.body = translation.delete_confirm.body_plural;
    }

    // Loop through all the selected funding rules and send delete API request
    const _this = this;

    confirm(
      msg,
      () => {
        for(let i = 0; i < _this.state.selectedRows.length; i++) {
          _this.props.store.VoucherStore.deleteVoucher(_this.state.selectedRows[i])
        }

        _this.setState({
          selectedRows: []
        });
      }
    );
  }

  render() {
    const { translation } = this.props;
    const { VoucherStore } = this.props.store;

    return(
      <main tabIndex="0" id="main-content" className="page">
        <header className="page__header">
          <div className="wrap">
            <h1 className="page__title">{translation.page_title}</h1>

            <div className="page__actions actions">
              <button className="actions__btn actions__btn--secondary" onClick={(e) => toggleDrawer(e, this, 'AddVoucher')}>
                <icons.iconPlus />
                {translation.create_vouchers}
              </button>
            </div>
          </div>
        </header>

        <VoucherList
          {...this.props}
          vouchers={VoucherStore.vouchers}
          parent={this}
          toggleDrawer={toggleDrawer}
          selectedRows={this.state.selectedRows}
        />

        <Delayed
          mounted={this.state.selectedRows.length > 0}
          unmountAfter={250}
        >
          <Toolbar
            selectedRows={this.state.selectedRows}
            deleteText={translation.delete}
            deleteFunction={this.deleteVouchers}
            {...this.props}
          />
        </Delayed>

        <Drawer
          content={this.state.drawerContent}
          isOpen={this.state.drawerOpen}
          parent={this}
          {...this.props}
          voucherSid={this.state.voucherSid}
        />
      </main>
    )
  }
})

export default translate('Vouchers')(Vouchers);


// WEBPACK FOOTER //
// ./src/app/components/Vouchers/Vouchers.js